module.exports = __webpack_public_path__ + "img/praxispay-gccBrokers.3c0471ce.png";